import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    const isInitialRender = isFirstRender.current;
    if (isInitialRender) {
      isFirstRender.current = false;
    }

    if (hash) {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      window.requestAnimationFrame(() => {
        target?.scrollIntoView();
      });
      return;
    }

    if (isInitialRender) return;

    // Route changes without hash should jump to top immediately.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
